import { FC, Suspense, useCallback, useContext } from 'react';
import { useParams, useNavigate } from 'react-router';

import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { AuthContext } from '@modules/Auth/contexts';

import { useProgramLink } from '../hooks/useProgramLink';
import { ProgramWelcome } from '../partials/ProgramWelcome';
import { ProgramPreview } from '../partials/ProgramPreview';


const RETURN_URL_KEY = 'stc_return_url';
export const LAST_PROGRAM_SLUG_KEY = 'stc_last_program_slug';

const ProgramLinkContent: FC<{ slug: string }> = ({ slug }) => {
  const { program } = useProgramLink(slug);
  const { isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  // Remember last visited program slug for logout redirect
  sessionStorage.setItem(LAST_PROGRAM_SLUG_KEY, slug);

  const handleBegin = useCallback(() => {
    if (!isLoggedIn) {
      // Save intended destination and redirect to login
      sessionStorage.setItem(RETURN_URL_KEY, `/programs/${slug}`);
      navigate('/auth/login');
    } else {
      navigate(`/programs/enroll/${program.id}`);
    }
  }, [navigate, program.id, slug, isLoggedIn]);

  if (!isLoggedIn) {
    return <ProgramPreview program={program} onGetStarted={handleBegin}/>;
  }

  return <ProgramWelcome program={program} onBegin={handleBegin}/>;
};

export const ProgramLinkLanding: FC = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) return null;

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="60vh"/>}>
        <ProgramLinkContent slug={slug}/>
      </Suspense>
    </ErrorBoundary>
  );
};
